import React, { useContext, useEffect, useState } from "react";
import {
  useSearchResultsHelper,
  SearchResultsState,
} from "./useSearchResultsHelper";
import { AppStore } from "../../app/store";
import { CollapsibleBox, PlanCard } from "../../components";
import { getPlanCard } from "../../api";
import {
  makePlanLongId,
  parsePlanLongIdIntoUrlPartForApi,
} from "../../helpers";
import { LowIncomeSubsidyStatus } from "../../@types";
import { Alert } from "@cmsgov/ds-medicare-gov";

const CoveragePlanCard: React.FC<{
  useCurrentCoverage: boolean;
  pageState: SearchResultsState;
}> = ({ useCurrentCoverage, pageState }) => {
  const { state, dispatch } = useContext(AppStore.AppContext);
  const [coverage, setCoverage] = useState(
    useCurrentCoverage ? state.currentCoverage : state.nextYearCoverage
  );
  const {
    handleAddToCompareClick,
    handleRemovePlanFromCompare,
  } = useSearchResultsHelper(state, dispatch, pageState);

  useEffect(() => {
    (async () => {
      /**
       * state.nextYearCoverage contains rollover plan information, but on this card sometimes a bene can have rollover information and already be enrolled in a different future plan.
       * Since the object in bene.future_coverage[0] does not have enough information to fill out a plan card, We need an API call to be made for more plan information here.
       */
      const futureCoverage = state.beneficiary?.future_coverage[0];
      if (!useCurrentCoverage && futureCoverage) {
        const plan = await getPlanCard(
          parsePlanLongIdIntoUrlPartForApi(makePlanLongId(futureCoverage)),
          state.pharmacies.map(pharmacy => pharmacy.npi),
          state.futureLis || LowIncomeSubsidyStatus.LIS_NO_HELP
        );
        setCoverage(plan);
      }
    })();
  }, []);

  const labelId = useCurrentCoverage
    ? "plan_card.your_current_plan"
    : "plan_card.your_next_plan";
  const dataTestId = useCurrentCoverage
    ? "current-plan-card"
    : "future-plan-card";

  if (!coverage) return null;

  return (
    <CollapsibleBox
      labelId={labelId}
      open
      titleClassname="current-plan-toggle e2e-current-plan-toggle"
    >
      {coverage ? (
        <PlanCard
          handleAddToCompare={handleAddToCompareClick}
          handleRemoveFromCompare={handleRemovePlanFromCompare}
          isCurrentPlan={true}
          key={coverage.contract_id}
          labelId={labelId}
          plan={coverage}
          dataTestId={dataTestId}
        />
      ) : (
        <Alert />
      )}
    </CollapsibleBox>
  );
};

export default CoveragePlanCard;
